<template>
  <div class="signature-container">
    <el-row :gutter="20">
      <el-col :span="15">
        <!-- 签名画布 -->
        <canvas
          ref="canvas"
          width="1200"
          height="600"
          style="width: 600px; height: 300px"
          @mousedown="startDrawing"
          @mousemove="draw"
          @mouseup="stopDrawing"
          @mouseleave="stopDrawing"
          @touchstart.prevent="startDrawing"
          @touchmove.prevent="draw"
          @touchend.prevent="stopDrawing"
        ></canvas>
      </el-col>

      <el-col :span="9">
        <!-- 控制区域 -->
        <div class="control-panel">
          <el-button-group>
            <el-button type="danger" @click="clearCanvas">
              <i class="el-icon-delete"></i> 清空
            </el-button>
            <el-button type="warning" @click="undo">
              <i class="el-icon-refresh-left"></i> 撤销
            </el-button>
            <!-- <el-button type="success" @click="saveAsImage">
              <i class="el-icon-download"></i> 保存
            </el-button> -->
          </el-button-group>

          <!-- 画笔设置 -->
          <div class="brush-settings">
            <el-slider
              v-model="brushSize"
              :min="1"
              :max="20"
              label="画笔粗细"
            ></el-slider>

            <el-color-picker
              v-model="brushColor"
              show-alpha
              label="画笔颜色"
            ></el-color-picker>
          </div>

          <!-- 预览 -->
          <!-- <div v-if="imageUrl" class="preview">
            <img :src="imageUrl" alt="签名预览" />
            <el-link type="primary" :href="imageUrl" download="signature.png">
              点击下载
            </el-link>
          </div> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
//   props: {
//     dialogSignatureFormVisible: {
//         type: Boolean,
//         default: false
//     }
//   },
  data() {
    return {
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      paths: [],
      currentPath: [],
      brushSize: 3,
      brushColor: "#000000",
      imageUrl: "",
    //   dialogSignatureFormVisible: false
    };
  },
  mounted() {
    // console.log(dialogSignatureFormVisible,this.dialogSignatureFormVisible)
    this.initCanvas();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      const baseWidth = 1200;
      const baseHeight = 600;

      canvas.width = baseWidth;
      canvas.height = baseHeight;

      canvas.style.width = "600px";
      canvas.style.height = "300px";

      //   canvas.width = rect.width * dpr;
      //   canvas.height = rect.height * dpr;
      //   canvas.style.width = `${rect.width}px`;
      //   canvas.style.height = `${rect.height}px`;

      this.ctx = canvas.getContext("2d");
      this.ctx.scale(dpr, dpr);
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.fillStyle = '#ffffff';
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
    },

    clearCanvas() {
      const canvas = this.$refs.canvas;
      
      // 正确清除整个画布
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // 立即提交清除操作
      this.ctx.beginPath();
      this.ctx.fillStyle = '#ffffff'; // 重置背景色
      this.ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // 重置数据存储
      this.paths = [];
      this.currentPath = [];
      
      // 强制重绘画布
      this.ctx.stroke();
      this.ctx.drawImage(canvas, 0, 0);
    },

    startDrawing(e) {
      this.isDrawing = true;
      const pos = this.getPosition(e);
      [this.lastX, this.lastY] = [pos.x, pos.y];
      this.currentPath = [{ x: pos.x, y: pos.y }];
    },

    draw(e) {
      if (!this.isDrawing) return;

      const pos = this.getPosition(e);
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(pos.x, pos.y);

      this.ctx.strokeStyle = this.brushColor;
      this.ctx.lineWidth = this.brushSize;

      this.ctx.stroke();
      [this.lastX, this.lastY] = [pos.x, pos.y];
      this.currentPath.push({ x: pos.x, y: pos.y });
    },

    stopDrawing() {
      if (this.isDrawing) {
        this.paths.push(this.currentPath);
        this.currentPath = [];
      }
      this.isDrawing = false;
    },

    clearCanvas() {
      this.ctx.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
      this.paths = [];
    },

    undo() {
      if (this.paths.length === 0) return;
      this.paths.pop();
      this.redraw();
    },

    redraw() {
      this.ctx.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );

      this.paths.forEach((path) => {
        this.ctx.beginPath();
        path.forEach((point, index) => {
          if (index === 0) {
            this.ctx.moveTo(point.x, point.y);
          } else {
            this.ctx.lineTo(point.x, point.y);
          }
        });
        this.ctx.stroke();
      });
    },

    saveAsImage() {
      const canvas = this.$refs.canvas;

      const tempCanvas = document.createElement("canvas");
      const tempCtx = tempCanvas.getContext("2d");

      tempCanvas.width = canvas.width;
      tempCanvas.height = canvas.height;
      tempCtx.fillStyle = "#ffffff";
      tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
      tempCtx.drawImage(canvas, 0, 0);

      this.imageUrl = tempCanvas.toDataURL("image/png");
    //   this.dialogSignatureFormVisible = false;
      this.$emit("saveAsImage", this.imageUrl);
    },

    getPosition(e) {
      const canvas = this.$refs.canvas;
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;

      let clientX, clientY;

      if (e.type.startsWith("touch")) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }

      return {
        x: (clientX - rect.left) * scaleX,
        y: (clientY - rect.top) * scaleY,
      };
    },

    handleResize() {
      this.initCanvas();
      this.redraw();
    },
  },
};
</script>

<style scoped>
.signature-container {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
  /* width: 100%;
  max-width: 1200px;
  margin: 0 auto; */
}

canvas {
  border: 2px solid #ebeef5;
  border-radius: 4px;
  background: white;
  touch-action: none; /* 禁用触摸默认行为 */
  cursor: crosshair;
}

.control-panel {
  padding: 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.brush-settings {
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.preview {
  margin-top: 20px;
  text-align: center;
}

.preview img {
  max-width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 10px;
}

.el-button-group {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.el-slider {
  margin: 15px 0;
}
</style>
